import * as constants from './constants';

const convertIP4toInt = (ip: string) => ip
    .split('.')
    .reduce((int, oct) => (int << 8) + parseInt(oct), 0) >>> 0;

const isIP4inCIDR = (ip: string) => (cidr: string) => {
    const [range, bits = '32'] = cidr.split('/');
    const mask = ~(2 ** (32 - parseInt(bits)) - 1);

    return (convertIP4toInt(ip) & mask) === (convertIP4toInt(range) & mask);
};

export const isIP4inCIDRs = (customList: { cidr: string }[], companyList: string, ip: string) => {
    const cidrs = customList
        .flatMap((item) => item.cidr.split(','))
        .concat(companyList.split(','))
        .concat(constants.DEFAULT_IP_WHITELIST.split(','))
        .map((cidr) => cidr.trim());

    return cidrs.some(isIP4inCIDR(ip));
};
